import {
	Box,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { useState } from "react";
import CommCard from "src/common/CommCard";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import { CommonPagination } from "src/common/CommonPagination";
import type { IFairStallList } from "src/Utils/type";
import FairStallTableRow from "./FairStallTableRow";
import StallCreateOptions from "./CreateFairStall/CreateOptions";

const FairStallList = () => {
	const [hall, setHall] = useState<string>("");
	const [status, setStatus] = useState<string>("");

	const [pagination, setPagination] = useState({
		limit: 50,
		skip: 0,
	});

	const { data: stalls, isLoading } = useGetQueryWithTotal<IFairStallList[]>({
		endPoint: `/api/fair/stall`,
		queryKeys: ["FairStalls", hall, status],
		params: { hall, status, ...pagination },
	});

	return (
		<CommCard
			headerTitle={`Stall List (${stalls?.total || 0})`}
			helmetTitle='BTTF - Stall list'
			showCardHeader
			statusOptions={[
				{
					id: "",
					name: "All",
				},
				{
					id: "sold",
					name: "Sold",
				},
				{
					id: "available",
					name: "Available",
				},
				{
					id: "reserved",
					name: "Reserved",
				},
				{
					id: "booked",
					name: "Booked",
				},
			]}
			showStatus1
			statusLabel1='Hall Name'
			statusOptions1={[
				{
					id: "",
					name: "All",
				},
				{
					id: "Carnival",
					name: "Carnival",
				},
				{
					id: "Celebrity",
					name: "Celebrity",
				},
				{
					id: "Harmony",
					name: "Harmony",
				},
				{
					id: "MilkyWay",
					name: "MilkyWay",
				},
			]}
			handleSelectStatus={(status) => setStatus(status)}
			handleSelectStatus1={(status) => setHall(status)}
			showStatus
			componentChildren={
				<>
					<StallCreateOptions />
				</>
			}
		>
			<TableContainer>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>SL.</TableCell>
							<TableCell>Hall Name</TableCell>
							<TableCell>Stall Type</TableCell>
							<TableCell>Stall No.</TableCell>
							<TableCell>Status</TableCell>
							<TableCell>Actions</TableCell>
						</TableRow>
					</TableHead>

					{isLoading ? (
						<TableLoader />
					) : stalls?.data?.length ? (
						<TableBody>
							{stalls?.data.map((stall, idx) => {
								return (
									<FairStallTableRow
										key={stall.fair_stall_id}
										stall={stall}
										serial={idx + 1}
									/>
								);
							})}
						</TableBody>
					) : (
						<TableNotFound />
					)}
				</Table>

				<Box p={2}>
					<CommonPagination
						total={stalls?.total}
						paginationCalFun={(limit: number, skip: number) => {
							setPagination({ limit, skip });
						}}
					/>
				</Box>
			</TableContainer>
		</CommCard>
	);
};

export default FairStallList;
